import { __assign, __rest } from "tslib";
import React from 'react';
import StandardThumb from '../../DeviationViews/Thumb/Standard';
import MeasuredTorpedo from '../MeasuredTorpedo';
import { getDeviationEntityId } from '../../redux/normalizr/schemas/deviation';
import MediaService from '../../utils/DeviationMediaService';
export var itemRenderer = function (renderProps, item, itemStyle) {
    return (React.createElement(StandardThumb, { key: "item-".concat(item.idx), deviation: item.dto.deviation, width: item.width, height: item.height, style: itemStyle }));
};
var DeviationTorpedo = function (_a) {
    var itemsFromProps = _a.items, torpedoProps = __rest(_a, ["items"]);
    var items = itemsFromProps.map(function (item) {
        var largest = MediaService.getThumbDimensions(item);
        return {
            id: "deviation-".concat(item.deviationId),
            width: largest.width,
            height: largest.height,
            deviation: item,
            duperbrowseItemId: getDeviationEntityId(item),
        };
    });
    return (React.createElement(MeasuredTorpedo, __assign({ items: items, renderItem: itemRenderer }, torpedoProps)));
};
DeviationTorpedo.displayName = 'DeviationTorpedo';
export default DeviationTorpedo;
//# sourceMappingURL=DeviationTorpedo.js.map